import React from 'react';
import {
  Box,
  Card,
  CardHeader,
  Divider,
  Link,
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';


import EmptyState from 'src/components/EmptyState';
import HttpLedger from 'src/components/HttpLedger';
import Button from 'src/components/Button';
import Label from '../../components/Label';
import RelativeDate from '../../components/RelativeDate';
import EngagementNameCell from '../../components/cells/EngagementNameCell';
import EngagementStatusCell from '../../components/cells/EngagementStatusCell';


function EngagementsLedgerCard({
  title,
  url
}: {
  title: string,
  url: string,
}) {
  const columns = [
    {
      title: 'Name',
      cellContent: (result: any) => <EngagementNameCell engagement={result} />,
    },
    {
      title: 'Current step',
      cellContent: (result: any) => <Label color="warning">{result.stepName}</Label>,
    },
    {
      title: 'Last activity',
      cellContent: (result: any) => <RelativeDate datetime={result.lastActivity} />,
    },
    {
      title: 'Status',
      cellContent: (result: any) => <EngagementStatusCell engagement={result} />,
    },
  ];

  return (
    <Card>
      <CardHeader title={title} />
      <Divider />
      <HttpLedger
        defaultPageSize={6}
        url={url}
        columns={columns}
        emptyState={<EmptyState />}
        defaultFilters={{
          is_incomplete: 'True'
        }}
      />
      <Box
        p={2}
        display="flex"
        justifyContent="flex-end"
      >
        <Button
          component={RouterLink}
          size="small"
          to="/engagements"
        >
          See all
          <NavigateNextIcon />
        </Button>
      </Box>
    </Card>
  );
}

export default EngagementsLedgerCard;
